enum MapViewItemType {
  Line = 'line',
  TextBox = 'text-box',
}

export default MapViewItemType
